import './index.scss'
import {useEffect, useState, memo, useRef} from 'react'
import {Swiper, SwiperSlide} from 'swiper/react'
import SwiperCore, {Pagination} from 'swiper'
import uptimeIcon from '../../../assets/images/uptime.svg'
import pingIcon from '../../../assets/images/ping.svg'
import jsonIcon from '../../../assets/images/json.svg'
import keywordIcon from '../../../assets/images/keyword.svg'
import sitemapIcon from '../../../assets/images/sitemap.svg'
import udpIcon from '../../../assets/images/udp.svg'
import tcpIcon from '../../../assets/images/tcp.svg'
import mailServerIcon from '../../../assets/images/mail-server.svg'
import statusCodeIcon from '../../../assets/images/status-code.png'
import {ArrowLeftIcon, ArrowRightIcon} from '../../../icons'
import classNames from 'classnames'
import Tooltip from '../tooltip'
import text from './text.json'
import limitManager from '../../../utils/limitManager'
import {colors} from '../../../utils/colors'

const resourceIcons = {
    uptime_icon: uptimeIcon,
    ping_icon: pingIcon,
    json_icon: jsonIcon,
    keyword_icon: keywordIcon,
    sitemap_icon: sitemapIcon,
    udp_icon: udpIcon,
    tcp_icon: tcpIcon,
    mail_server_icon: mailServerIcon,
    status_code_icon: statusCodeIcon
}

SwiperCore.use([Pagination])

function IconCardSlider(props) {
    const [swiper, setSwiper] = useState(null)
    const [isBegin, setIsBegin] = useState(true)
    const [isEnd, setIsEnd] = useState(true)
    const currentSlideIndex = props.slides.findIndex((slide) => slide.active)
    const currentSlide = props.slides[currentSlideIndex]
    const isOnPaidPremium = limitManager.isPaidPlan()
    const containerRef = useRef(null)

    useEffect(() => {
        if (swiper) {
            setIsBegin(swiper.isBeginning)
            setIsEnd(swiper.isEnd)
        }
    }, [swiper])

    useEffect(() => {
        if (swiper && currentSlideIndex) {
            swiper.slideTo(currentSlideIndex)
        }
    }, [swiper, currentSlideIndex, props.mustSlideToStartOnChange])

    const slideChangeHandler = () => {
        setIsBegin(swiper.isBeginning)
        setIsEnd(swiper.isEnd)
    }

    return (
        <div className="icon-card-slider" ref={containerRef}>
            <div className="card-slider">
                <div className="arrow-button" onClick={() => swiper.slidePrev()}>
                    <ArrowLeftIcon color={isBegin ? colors.colorLightGrey : colors.colorMuted} />
                </div>
                <Swiper
                    slidesPerView={2}
                    spaceBetween={12}
                    breakpoints={{
                        505: {
                            slidesPerView: 3
                        },
                        630: {
                            slidesPerView: 4
                        },
                        830: {
                            slidesPerView: 5
                        },
                        982: {
                            slidesPerView: 6
                        },
                        1085: {
                            slidesPerView: 7
                        },
                        1240: {
                            slidesPerView: 8
                        }
                    }}
                    navigation
                    pagination={{
                        clickable: true
                    }}
                    modules={[Pagination]}
                    className="mySwiper"
                    onSwiper={setSwiper}
                    onSlideChange={slideChangeHandler}
                >
                    {props.slides.map((slide, index) => {
                        const onClick = () => {
                            if (slide.disabled) return
                            slide.onClick()
                        }
                        return (
                            <SwiperSlide key={slide.key} onClick={onClick}>
                                {slide.disabled ?
                                    <Tooltip
                                        trigger="mouseenter"
                                        placement="top"
                                        content={slide?.isDiffType ? text.cannot_change : !isOnPaidPremium && text.premium_feature}
                                        btnClassName='w-100'
                                        appendTo={containerRef?.current}
                                    >
                                        <div className={classNames(
                                            'slide-content',
                                            {
                                                'active': slide.active,
                                                'disabled': slide.disabled
                                            }
                                        )}>
                                            <div className="icon-wrapper">
                                                <img
                                                    src={resourceIcons[slide.icon]}
                                                    alt={slide.key}
                                                    className="icon"
                                                />
                                            </div>
                                            <div className="title">{slide.title}</div>
                                        </div>
                                    </Tooltip> :
                                    <div className={classNames(
                                        'slide-content',
                                        {
                                            'active': slide.active,
                                            'disabled': slide.disabled
                                        }
                                    )}>
                                        <div className="icon-wrapper">
                                            <img
                                                src={resourceIcons[slide.icon]}
                                                alt={slide.key}
                                                className="icon"
                                            />
                                        </div>
                                        <div className="title">{slide.title}</div>
                                    </div>}
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
                <div className="arrow-button" onClick={() => swiper.slideNext()}>
                    <ArrowRightIcon color={isEnd ? colors.colorLightGrey : colors.colorMuted} />
                </div>
            </div>
            <div className="info-wrapper">
                <div className='slider-info-box'>
                    {currentSlide && (currentSlide.info_text)}
                </div>
            </div>
        </div>
    )
}

export default memo(IconCardSlider)
